// Transformation

export const TRANSFORM_MENU_SECTION = {
	key: 'transform-menu-section',
};

export const TRANSFORM_MENU_ITEM = {
	key: 'transform-menu-item',
};

export const TRANSFORM_CREATE_MENU_SECTION = {
	key: 'transform-create-menu-section',
};

export const TRANSFORM_HEADINGS_MENU_SECTION = {
	key: 'transform-headings-menu-secion',
};

export const TRANSFORM_HEADINGS_H1_MENU_ITEM = {
	key: 'transform-headings-h1-menu-item',
};

export const TRANSFORM_HEADINGS_H2_MENU_ITEM = {
	key: 'transform-headings-heading-2-menu-item',
};

export const TRANSFORM_HEADINGS_H3_MENU_ITEM = {
	key: 'transform-headings-heading-3-menu-item',
};

export const TRANSFORM_HEADINGS_H4_MENU_ITEM = {
	key: 'transform-headings-heading-4-menu-item',
};

export const TRANSFORM_HEADINGS_H5_MENU_ITEM = {
	key: 'transform-headings-heading-5-menu-item',
};

export const TRANSFORM_HEADINGS_H6_MENU_ITEM = {
	key: 'transform-headings-heading-6-menu-item',
};

export const TRANSFORM_SUGGESTED_MENU_SECTION = {
	key: 'transform-suggested-menu-section',
};

export const TRANSFORM_STRUCTURE_MENU_SECTION = {
	key: 'transform-structure-menu-section',
};

export const TRANSFORM_SUGGESTED_MENU_ITEM = {
	key: 'transform-suggested-menu-item',
};

export const TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM = {
	key: 'transform-structure-bulleted-list-menu-item',
};

export const TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM = {
	key: 'transform-structure-task-list-menu-item',
};

export const TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM = {
	key: 'transform-structure-numbered-list-menu-item',
};

export const TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM = {
	key: 'transform-structure-code-block-menu-item',
};

export const TRANSFORM_STRUCTURE_PANEL_MENU_ITEM = {
	key: 'transform-structure-panel-menu-item',
};

export const TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM = {
	key: 'transform-structure-expand-menu-item',
};

export const TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM = {
	key: 'transform-structure-layout-menu-item',
};

export const TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM = {
	key: 'transform-structure-quote-menu-item',
};

export const TRANSFORM_STRUCTURE_DECISION_MENU_ITEM = {
	key: 'transform-structure-decision-menu-item',
};

export const TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM = {
	key: 'transform-structure-paragraph-menu-item',
};

export const TRANSFORM_CLEAR_MENU_SECTION = {
	key: 'transform-clear-menu-section',
};

export const TRANSFORM_CLEAR_MENU_ITEM = {
	key: 'transform-clear-menu-item',
};

export const TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM = {
	key: 'transform-default-extension-slot-menu-item',
};

// Block actions

export const BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM = {
	key: 'block-actions-featured-extension-slot-menu-item',
};

export const BLOCK_ACTIONS_TEMPLATE_SECTION = {
	key: 'block-actions-template-section' as const,
};

export const BLOCK_ACTIONS_FEATURED_EXTENSION_SECTION_KEYS: readonly [
	typeof BLOCK_ACTIONS_TEMPLATE_SECTION.key,
] = ['block-actions-template-section'];

export const BLOCK_ACTIONS_MENU_SECTION = {
	key: 'block-actions-menu-section',
};

export const BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM = {
	key: 'block-actions-create-synced-block-menu-item',
};

export const BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM = {
	key: 'block-actions-copy-link-to-block-menu-item',
};

export const BLOCK_ACTIONS_COPY_MENU_SECTION = {
	key: 'block-actions-copy-menu-section',
};

// Position

export const POSITION_MENU_SECTION = {
	key: 'position-menu-section',
};

export const POSITION_MOVE_UP_MENU_ITEM = {
	key: 'position-move-up-menu-item',
};

export const POSITION_MOVE_DOWN_MENU_ITEM = {
	key: 'position-move-down-menu-item',
};

// Delete

export const DELETE_MENU_SECTION = {
	key: 'delete-menu-section',
};

export const DELETE_MENU_ITEM = {
	key: 'delete-menu-item',
};

export const BLOCK_MENU_TEST_ID = 'editor-block-menu';

// Experience tracking test IDs
// Used by experience tracking to detect menu action clicks

export const BLOCK_MENU_ACTION_TEST_ID = {
	MOVE_UP: 'block-menu-move-up',
	MOVE_DOWN: 'block-menu-move-down',
	DELETE: 'block-menu-delete',
	COPY_LINK: 'block-menu-copy-link',
} as const;

/** Test ID for extension menu items (used to skip block transform experience tracking) */
export const EXTENSION_MENU_ITEM_TEST_ID = 'extension-menu-item';

// AI
export const AI_MENU_SECTION = {
	key: 'ai-menu-section',
};

/**
 * Minimum text length (in characters) for AI block menu actions
 * (e.g. "Improve formatting", "Remix") to be visible.
 */
export const AI_BLOCK_MENU_LARGE_TEXT_THRESHOLD = 300;

export const AI_ASK_ROVO_MENU_ITEM = {
	key: 'block-menu-ai-ask-rovo-menu-item',
};

export const AI_IMPROVE_WRITING_MENU_ITEM = {
	key: 'block-menu-ai-improve-writing-menu-item',
};

export const AI_POLISH_MENU_ITEM = {
	key: 'block-menu-ai-polish-menu-item',
};

export const AI_REMIX_MENU_ITEM = {
	key: 'block-menu-ai-remix-menu-item',
};
